/* eslint sort-keys: 0 */

import React from "react";
import PropTypes from "prop-types";
import Downshift from "downshift";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";

function renderInput(inputProps) {
  const { InputProps, classes, ref, ...other } = inputProps;

  return (
    <TextField
      InputProps={{
        ...InputProps,
        classes: {
          root: classes.inputRoot,
        },
        inputRef: ref,
      }}
      {...other}
    />
  );
}

function renderSuggestion({
  suggestion,
  index,
  itemProps,
  highlightedIndex,
  selectedItem,
}) {
  const isHighlighted = highlightedIndex === index;
  const isSelected = (selectedItem || "").indexOf(suggestion.label) > -1;
  return (
    <MenuItem
      {...itemProps}
      key={suggestion.value}
      selected={isHighlighted}
      component="div"
      value={suggestion}
      style={{
        fontWeight: isSelected ? 500 : 400,
      }}
    >
      {suggestion.label}
    </MenuItem>
  );
}
renderSuggestion.propTypes = {
  highlightedIndex: PropTypes.number,
  index: PropTypes.number,
  itemProps: PropTypes.object,
  selectedItem: PropTypes.object,
  suggestion: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number,
  }).isRequired,
};

function getSuggestions(inputValue, suggestions) {
  let count = 0;

  return suggestions.filter((suggestion) => {
    const keep =
      (!inputValue ||
        suggestion.label.toLowerCase().indexOf(inputValue.toLowerCase()) !==
          -1) &&
      count < 10;

    if (keep) {
      count += 1;
    }

    return keep;
  });
}

/* eslint sort-keys: 0 */
/* tslint sort-keys: 0 */
const styles = (theme) => ({
  chip: {
    margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`,
  },
  container: {
    flexGrow: 1,
    position: "relative",
  },
  divider: {
    height: theme.spacing.unit * 2,
  },
  inputRoot: {
    flexWrap: "wrap",
  },
  paper: {
    position: "absolute",
    zIndex: 1,
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0,
  },
  root: {
    flexGrow: 1,
    height: 250,
  },
});

function IntegrationDownshift(props) {
  console.log(props);
  const { classes, options, onSelected, productInputPointer } = props;

  return (
    <div className={classes.root} style={{ marginTop: "1rem" }}>
      <Downshift
        id="product-name"
        onChange={(selectedItem) => {
          if (selectedItem) {
            const item = options.find(
              (option) => option.label === selectedItem
            );
            if (item) {
              onSelected(item);
            }
          }
        }}
      >
        {({
          getInputProps,
          getItemProps,
          isOpen,
          inputValue,
          selectedItem,
          highlightedIndex,
        }) => (
          <div className={classes.container}>
            {renderInput({
              fullWidth: true,
              classes,
              InputProps: getInputProps({
                placeholder: "Ingrese el nombre del producto",
                onFocus: (e) => {
                  if (selectedItem) {
                    console.log(e.target.select());
                  }
                },
                onBlur: (e) => {
                  if (selectedItem) {
                    productInputPointer(e.target);
                  }
                },
              }),
            })}
            {isOpen ? (
              <Paper className={classes.paper} square>
                {getSuggestions(inputValue, options).map((suggestion, index) =>
                  renderSuggestion({
                    suggestion,
                    index,
                    itemProps: getItemProps({ item: suggestion.label }),
                    highlightedIndex,
                    selectedItem,
                  })
                )}
              </Paper>
            ) : null}
          </div>
        )}
      </Downshift>
    </div>
  );
}

IntegrationDownshift.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(IntegrationDownshift);



// WEBPACK FOOTER //
// ./src/components/SelectAutocomplete.jsx